<template>
  <v-container>
    <v-card elevation="0" rounded v-if="systemNotificationStatus == 'granted'">
      <v-breadcrumbs
        :items="[{ text: 'Dashboard', to: '/' }]"
        divider="-"
      ></v-breadcrumbs>
      <v-card-title>
        My Notifications
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" lg="4" xl="4" md="12" sm="12">
            <v-btn
              v-if="!showCreateForm"
              color="orange lighten-2"
              elevation="0"
              block
              large
              @click="toggleForm()"
              >Create Notification</v-btn
            >
            <v-expand-x-transition>
              <div v-if="showCreateForm">
                <h3 class="text-subtitle-1">New Notification</h3>
                <v-divider></v-divider>
                <v-form ref="formNotification">
                  <div class="text-center mb-5">
                    <v-btn-toggle
                      rounded
                      v-model="newNotification.notificationType"
                      background-color="white"
                      class="my-4 mx-auto text-center"
                      color="primary"
                    >
                      <v-btn active-class="primary white--text" :value="0">
                        By District
                      </v-btn>

                      <v-btn active-class="primary white--text" :value="1">
                        By Block Names
                      </v-btn>

                      <v-btn active-class="primary white--text" :value="2">
                        By Pincode
                      </v-btn>
                    </v-btn-toggle>

                    <v-btn-toggle
                      rounded
                      v-model="newNotification.dose"
                      class="text-center d-block"
                      mandatory
                      dense
                    >
                      <v-btn active-class="green lighten-2" :value="1">
                        <v-icon small>mdi-needle</v-icon> Dose 1
                      </v-btn>

                      <v-btn
                        active-class="yellow lighten-1"
                        outlined
                        :value="2"
                      >
                        <v-icon small>mdi-needle</v-icon> Dose 2
                      </v-btn>
                    </v-btn-toggle>
                    <v-radio-group
                      hide-details
                      v-model="newNotification.age"
                      row
                      class="mb-4"
                      label="Min. Age Limit"
                    >
                      <v-radio label="18+" :value="18"></v-radio>
                      <v-radio label="40+" :value="40"></v-radio>
                      <v-radio label="45+" :value="45"></v-radio>
                    </v-radio-group>
                  </div>
                  <v-autocomplete
                    rounded
                    :items="states"
                    v-model="newNotification.state"
                    label="State"
                    item-text="state_name"
                    item-value="state_id"
                    outlined
                    dense
                    placeholder="State"
                    v-if="newNotification.notificationType < 2"
                  ></v-autocomplete>
                  <v-autocomplete
                    rounded
                    :items="districts"
                    v-model="newNotification.district"
                    item-text="district_name"
                    item-value="district_id"
                    label="District"
                    outlined
                    dense
                    placeholder="District"
                    @change="getBlocksByDistrict()"
                    v-if="newNotification.notificationType < 2"
                  ></v-autocomplete>
                  <v-expand-x-transition>
                    <v-autocomplete
                      rounded
                      :items="blocks"
                      v-model="newNotification.blocks"
                      item-text="block_name"
                      item-value="block_name"
                      label="Block"
                      outlined
                      color="primary"
                      dense
                      chips
                      clearable
                      deletable-chips
                      placeholder="Block"
                      v-if="newNotification.notificationType == 1"
                    ></v-autocomplete>
                  </v-expand-x-transition>

                  <v-expand-x-transition>
                    <v-combobox
                      rounded
                      counter-value
                      :rules="[rules.valid_pin,rules.required]"
                      v-model="newNotification.pincodes"
                      :items="pins"
                      :search-input.sync="search"
                      outlined
                      type="number"
                      label="Add Pincodes"
                      chips
                      clearable
                      item-color="primary"
                      deletable-chips
                      v-if="newNotification.notificationType == 2"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              Enter pincode and Press <kbd>enter</kbd>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-combobox>
                  </v-expand-x-transition>

                  <v-btn
                    @click="createNotification()"
                    color="primary"
                    class="mt-5"
                    elevation="0"
                    block
                    large
                    :disabled="checkFormField()"
                  >
                    <v-icon>mdi-plus-circle-outline</v-icon>
                    Add To Notifications</v-btn
                  >
                  <v-btn
                    text
                    class="mx-auto mt-5 d-block text-center"
                    @click="toggleForm()"
                    ><v-icon small>mdi-close</v-icon> Cancel</v-btn
                  >
                </v-form>
              </div>
            </v-expand-x-transition>
          </v-col>

          <v-col cols="12" lg="8" xl="8" md="12" sm="12">
            <h3 class="text-h5 mb-3">Subscribed Notifications</h3>
            <v-divider></v-divider>
            <v-card
              v-for="(sub, i) in allSubscriptions"
              :key="sub.id"
              elevation="1"
              class="mt-4 rounded-lg"
              rounded
            >
              <v-card-title>
                <h4 class="text-h6">Subscription {{ i + 1 }}</h4>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  icon
                  outlined
                  color="red"
                  @click="deleteSubscription(sub.id)"
                  ><v-icon small>mdi-delete</v-icon></v-btn
                >
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title> Dose </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-title> {{ sub.dose }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title> Age Group </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-title> {{ sub.age }}+ </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="sub.dis_or_pin < 2">
                    <v-list-item-content>
                      <v-list-item-title>District </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ getDistrictName(sub.district).district }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="sub.dis_or_pin < 2">
                    <v-list-item-content>
                      <v-list-item-title>State </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ getDistrictName(sub.district).state }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <div v-if="sub.dis_or_pin == 1" class="px-4">
                  <span class="black--text mb-2 d-block">
                    Block Subscribed 
                  </span>
                  <v-chip
                    small
                    color="deep-orange lighten-3"
                    class="mr-2 mb-2"
                    >{{ sub.blocks }}</v-chip
                  >
                </div>

                <div v-if="sub.dis_or_pin == 2" class="px-4">
                  <span class="black--text mb-2 d-block">
                    Pincode Subscribed
                  </span>
                  <v-chip
                    small
                    color="green lighten-3"
                    class="mr-2 mb-2"
                    >{{ sub.pincodes }}</v-chip
                  >
                </div>
              </v-card-text>
            </v-card>
            <v-alert
              outlined
              transition="scale-transition"
              icon="mdi-emoticon-sad-outline"
              type="error"
              class="rounded-lg mt-4 text-center"
              dense
              v-if="allSubscriptions.length == 0"
              elevation="0"
            >
              No subscription found.
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card
      class="text-center"
      v-else-if="systemNotificationStatus == 'denied'"
    >
      <v-card-text>
        <v-img
          contain
          class="mx-auto d-block"
          src="/img/notification.png"
          alt="sdkjdhsk"
          height="200"
        ></v-img>
      </v-card-text>

      <v-card-title>
        <div class="text-center mx-auto text-h4 mb-2">
          Oops !! Notification permission denied for this site.
        </div>
      </v-card-title>
      <v-card-subtitle>
        Please go to browser settings and enable notification for this site.
        <br />
        <a
          target="_blank"
          href="https://support.google.com/chrome/answer/3220216?co=GENIE.Platform%3DDesktop&hl=en"
          >How to enable notification on Google Chrome ?</a
        >
        <br />
        <a
          target="_blank"
          href="https://www.lifewire.com/how-to-enable-disable-firefox-notifications-4588164"
          >How to enable notification on Mozilla ?</a
        >
      </v-card-subtitle>
    </v-card>
    <v-card v-else>
      <v-card-text class="text-center">
        <v-btn
          v-if="!iOS()"
          color="primary"
          x-large
          elevation="0"
          @click="requestNotification()"
          >Enable Notification</v-btn
        >
        <p v-else class="text-h5">
          iPhone doesn't support notification from browser. 😒
        </p>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" :timeout="2000">
      {{ snackbarMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary lighten-1"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import { messaging, remoteConfig } from "../firebase/firebase";
export default {
  data: () => ({
    search: "",
    column: "",
    snackbar: false,
    snackbarMessage: "",
    pins: [],
    showCreateForm: false,
    notificationType: "district",
    newNotification: {
      district: "",
      state: "",
      blocks: "",
      age: 18,
      dose: 1,
      pincodes: "",
      notificationType: 0,
    },
    blocks: [],
    allSubscriptions: [],
    systemNotificationStatus: "",
    rules: {
      required: (value) => !!value || "Required.",
      valid_pin: (value) => value.length == 6 || "Pin should be 6 digit number",
    },
  }),
  methods: {
    toggleForm() {
      this.showCreateForm = !this.showCreateForm;
    },
    getBlocksByDistrict() {
      axios
        .get(
          "https://kanak.digital/api/get_blocks/" +
            this.newNotification.district
        )
        .then((res) => {
          this.newNotification.blocks = '';
          this.blocks = res.data;
        });
    },
    createNotification() {
      var data = this.newNotification;

      messaging
        .getToken({
          vapidKey:
            "BBdKP0lNlxJ6tAieALertQc2KIV_p-U1euF7fK9bycOQRfUiFB-SspSQ9vt5_5s9dQXYN1B1ecH8dnCnGl-2wz4",
        })
        .then((token) => {
          console.log(token);
          data.token = token;

          axios
            .post("https://kanak.digital/api/create_notification", data)
            .then(() => {
              this.snackbar = true;
              this.snackbarMessage = "Successfully created new notification";
              this.getSubscriptions();
              this.newNotification = {
                district: "",
                state: "",
                blocks: '',
                age: 18,
                dose: 1,
                pincodes: '',
                notificationType: 0,
              };
              this.showCreateForm = false;
            });
        });
    },
    getSubscriptions() {
      messaging
        .getToken({
          vapidKey:
            "BBdKP0lNlxJ6tAieALertQc2KIV_p-U1euF7fK9bycOQRfUiFB-SspSQ9vt5_5s9dQXYN1B1ecH8dnCnGl-2wz4",
        })
        .then((token) => {
          axios
            .get("https://kanak.digital/api/get_nots_by_token/" + token)
            .then((res) => {
              // console.log(JSON.parse(res.data.blocks));
              this.allSubscriptions = res.data;
            });
        });
    },
    getDistrictName(district_id) {
      return this.$store.getters.getStateAndDistrict(district_id);
    },
    deleteSubscription(sub_id) {
      axios
        .delete("https://kanak.digital/api/delete_subscription/" + sub_id)
        .then(() => {
          this.getSubscriptions();
          this.snackbar = true;
          this.snackbarMessage = "Successfully deleted notification";
        });
    },
    requestNotification() {
      Notification.requestPermission().then((res) => {
        this.systemNotificationStatus = res;
      });
    },
    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
    checkFormField() {
      if (this.newNotification.notificationType == 0) {
        if (this.newNotification.district == "") {
          return true;
        }
      } else if (this.newNotification.notificationType == 1) {
        if (this.newNotification.blocks == "") {
          return true;
        }
      } else if (this.newNotification.notificationType == 2) {
        if (this.newNotification.pincodes == "") {
          return true;
        }
      }
    },
  },
  computed: {
    states() {
      return this.$store.getters.getAllStates;
    },
    districts() {
      return this.$store.getters.getDistrictByState(this.newNotification.state);
    },
  },
  created() {
    this.getSubscriptions();
    this.systemNotificationStatus = Notification.permission;
    console.log(remoteConfig.getAll("age_groups"));
  },
};
</script>

<style>
</style>